import React from 'react';
import './PricingSection.css';

const PricingSection = () => {
  return (
    <section id="pricing" className="pricing-section">

      {/* Hero headline */}
      <div className="hero-pitch">
        <h1>Own Your Music Store – One Payment, Lifetime Control</h1>
        <p className="hero-text">
          No platform fees. No subscriptions.
        </p>
        <p>
          Independent artists: Stop giving 10–20% cuts to Bandcamp, Sellfy, or
          Squarespace. Or having platforms dictate what you can sell.
          Sell ebooks, artwork, music, merch, apps — anything digital.
          Deploy your own fully‑featured store today. All you do is promote.
        </p>
      </div>

      {/* Pricing Tiers */}
      <div className="tier-container">


        {/* Tier 1 - Lifetime (Featured) */}
        <div className="tier-card tier-pro featured">
          <div className="tier-badge featured-badge">MOST POPULAR</div>
          <h3>Lifetime License</h3>
          <div className="tier-price">
            <span className="tier-amount">$249</span>
            <span className="tier-period">one time</span>
          </div>
          <div className="tier-total">Pay once. Own it forever.</div>
          <p className="tier-desc">
            Instant download. Deploy anywhere — Netlify, NearlyFreeSpeech, or any Node/MySQL host.
          </p>
          <ul className="tier-features">
            
            <li>✅ Built‑in Stripe gateway</li>
            <li>✅ Admin dashboard + your database</li>
            <li>✅ Preorder system + cart</li>
            <li>✅ ZIP download delivery</li>
            <li>✅ Mobile‑responsive design</li>
            <li>✅ Unlimited products, music, ebooks</li>
            <li>✅ 90-day bug fix support</li>
            <li>✅ Live preorder progress bar</li>
            <li>✅ Fill & manage featured products from Admin</li>
            <li>✅ Upload new products from Admin</li>
            <li>✅ Menu link for your BBBoard</li>
            <li>✅ Built-in MusicPlayer</li>
            <li>✅ Built-in VideoPlayer</li>
            <li>✅ Built-in Epub Modal</li>
            <li>✅ 3 free Themes</li>
            <li>✅ Simple setup</li>
            <li>✅ automatically generate tables in your Database</li>
            <li>✅ automatically loads images from folder they live in</li>
          </ul>
          <a href="#checkout" className="tier-button tier-button-pro">
            Buy Now – Instant Download
          </a>
        </div>

        {/* Tier 2 - Lifetime + Themes */}
        <div className="tier-card tier-elite">
          <div className="tier-badge elite-badge">BEST VALUE</div>
          <h3>Lifetime + Themes</h3>
          <div className="tier-price">
            <span className="tier-amount">$399</span>
            <span className="tier-period">one time</span>
          </div>
          <div className="tier-total">Store + 25 Premium Themes</div>
          <p className="tier-desc">
            Everything in Lifetime plus 25 custom-designed themes. Transform your store's look instantly.
          </p>
          <ul className="tier-features">
            <li>✅ Everything in Lifetime License</li>
            <li>✅ 25 premium themes included</li>
            <li>✅ One-click theme switching(Test all 25 with dropdown on right of page)</li>
            <li>✅ Support via Forum (all questions answered)</li>
           
          </ul>
          <a href="#checkout" className="tier-button tier-button-elite">
            Get Store + Themes
          </a>
        </div>

      </div>

      {/* Theme Add-ons Section */}
      <div className="addons-section">
        <h2>Buy Custom Themes</h2>
        <p>Already have the store? Add premium themes starting at $49. One-click install — drop the CSS files in Global.css or Index.css and go.</p>
        <div className="theme-thumbs">
          <div className="theme-thumb-card">
            <img src="/dark-thumb.jpg" alt="Dark Pro" />
            <span>Dark Pro</span>
            <strong>$49</strong>
          </div>
          <div className="theme-thumb-card">
            <img src="/neon-thumb.jpg" alt="Neon Cyber" />
            <span>Neon Cyber</span>
            <strong>$69</strong>
          </div>
          <div className="theme-thumb-card">
            <img src="/retro-thumb.jpg" alt="Retro Wave" />
            <span>Retro Wave</span>
            <strong>$49</strong>
          </div>
          <div className="theme-thumb-card">
            <img src="/luxury-thumb.jpg" alt="Luxury Gold" />
            <span>Luxury Gold</span>
            <strong>$79</strong>
          </div>
        </div>
        <a href="#themes" className="addons-link">Test All 25 Themes from MainPage→</a>
      </div>

         {/* Features Section */}
      <div className="features-section">
        <h2>Everything independent artists need</h2>
        <div className="features-grid">
          <div className="feature-block">
            <span className="feature-icon">🛒</span>
            <h4>Full Ecommerce</h4>
            <p>Products, cart, checkout, ZIP downloads — everything built in.</p>
          </div>
          <div className="feature-block">
            <span className="feature-icon">⚡</span>
            <h4>Stripe Built-In</h4>
            <p>You keep 100% after processor fees. No middleman.</p>
          </div>
          <div className="feature-block">
            <span className="feature-icon">🎛️</span>
            <h4>Admin Dashboard</h4>
            <p>Control inventory, pricing, and featured items from one place.</p>
          </div>
          <div className="feature-block">
            <span className="feature-icon">🎵</span>
            <h4>Preorder System</h4>
            <p>Fund your next album before it drops — set sales goals and go.</p>
          </div>
          <div className="feature-block">
            <span className="feature-icon">📱</span>
            <h4>Mobile First</h4>
            <p>Looks great on every device, every screen size.</p>
          </div>
          <div className="feature-block">
            <span className="feature-icon">🎨</span>
            <h4>Custom Themes</h4>
            <p>🎨 All 25 themes shown are available for preview. 
Tier 1 includes 3 free themes. Tier 2 includes all 25 free. 
Just want one specific theme? Individual themes available for purchase separately. All themes are easy to customize.</p>
          </div>

          {/* New Features Added */}
          <div className="feature-block">
            <span className="feature-icon">🗄️</span>
            <h4>Self-Generating Database</h4>
            <p>Automatically creates all required database tables — no manual setup needed. Your store is ready to go immediately.</p>
          </div>
          <div className="feature-block">
            <span className="feature-icon">🖼️</span>
            <h4>Automatic Image Loading</h4>
            <p>Drop artwork, albums, or book covers in the folder and the app detects them instantly — no database entry required.</p>
          </div>
        </div>
      </div>

      {/* Legal Footer */}
      <footer className="legal-footer">
        <p><strong>License:</strong> Personal/business use only. No resale/repackaging.</p>
        
        <p>Copyright © 2026 tccouram.</p>
      </footer>

    </section>
  );
};

export default PricingSection;
